import { useContext } from "react";
import { isDefaulter } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import AuthContext from "../../context/auth/AuthContext";
import CloseIcon from "../../assets/img/closeIcon.svg";
import notIcon from "../../assets/img/noticIcon.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";

const TenantProfileInsuranceModal = ({
  user,
  propertiesData,
  setShowPropertiesPopup,
  onClose,
  isOpen,
}) => {
  const { _t } = useTranslator();
  const { user: landlordUser } = useContext(AuthContext);
  const experianData =
    user?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.["s:Body"]
      ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

  const isInsurancePreApproved = !isDefaulter(experianData);

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup total-salary-modal default-check-modal ${
          isOpen ? "open" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="doc-history-header">
          <img
            src={CloseIcon}
            alt=""
            className="doc-history-close-btn"
            onClick={onClose}
          />
          <h4 className="custom-modal-heading">{_t("insurableCTAHeader")}</h4>
        </div>
        <div className="doc-history-content doc-history-content-insurance">
          {isInsurancePreApproved ? (
            <div className="d-flex align-items-start custom-gap-3">
              <div className="checkmarkWrapper">
                <img src="/images/checkmarkIconGreen.svg" alt="" />
              </div>
              <div className="d-flex flex-column custom-gap-3">
                <h4>{_t("insurancePreApproved")}</h4>
                <p>
                  {_t(
                    "thisTenantMeetsTheInitialCriteriaForInsuranceFinalApprovalWillDependOnTheRentalPriceAndTheTenantsTheyWillLiveWith"
                  )}
                </p>
                <div
                  data-tooltip-id="request-insurance-tooltip"
                  className="button-wrapper infodorpdown"
                >
                  <button
                    className="btnNext"
                    disabled={(propertiesData?.length ?? 0) === 0}
                    onClick={() => setShowPropertiesPopup(true)}
                  >
                    {_t("requestInsurance")}
                  </button>
                  {(propertiesData?.length ?? 0) === 0 && (
                    <ReactTooltip
                      id="request-insurance-tooltip"
                      noArrow
                      className="react-tooltip-styling details-skor-tooltip"
                      render={() => (
                        <p>
                          {" "}
                          {_t("youNeedToLinkThisTenantToAPropertyToEnableThis")}
                        </p>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-start custom-gap-3">
              <div
                className="checkmarkWrapper"
                style={{ background: "#FFE2E2" }}
              >
                <img src={notIcon} alt="" />
              </div>
              <div className="d-flex flex-column custom-gap-3">
                <h4>{_t("insuranceNotAvailable")}</h4>
                <p>
                  {_t(
                    "thisTEnantIsNotEligibleForTheDefaultInsuranceOrWouldNeedAManualReview"
                  )}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TenantProfileInsuranceModal;
